import { useState, useEffect, useRef } from 'react';
import { painPoints } from './constants';

export default function PainPoints() {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef<HTMLElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setIsVisible(true);
          }
        });
      },
      { threshold: 0.1 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  return (
    <section ref={sectionRef} className="py-20 bg-gradient-to-br from-slate-50 to-blue-50">
      <div className="container mx-auto px-6">
        <div className={`max-w-4xl mx-auto text-center mb-16 transition-all duration-1000 ${
          isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
        }`}>
          <h2 className="text-3xl md:text-4xl font-bold text-[#2a4b7c] mb-6">
            Vấn đề doanh nghiệp đang gặp phải
          </h2>
          <p className="text-lg text-slate-600">
            Hầu hết doanh nghiệp đều gặp những thách thức chung trong quản trị năng lực nhân sự
          </p>
        </div>
        
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mb-12">
          {painPoints.map((point, index) => (
            <div 
              key={index} 
              className={`bg-white p-6 rounded-xl shadow-sm border border-slate-100 hover:shadow-lg hover:-translate-y-1 transition-all duration-500 ${
                isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
              }`}
              style={{ transitionDelay: `${index * 100}ms` }}
            >
              <div className="flex items-start space-x-3">
                <div className="w-6 h-6 rounded-full bg-red-100 flex items-center justify-center flex-shrink-0 mt-1">
                  <i className="ri-close-line text-red-600 text-sm"></i>
                </div>
                <p className="text-slate-700 font-medium">{point}</p>
              </div>
            </div>
          ))}
        </div>

        <div className={`text-center transition-all duration-1000 delay-500 ${
          isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
        }`}>
          <div className="inline-flex items-center bg-gradient-to-r from-[#2a4b7c] to-[#3d5a80] text-white px-6 py-3 rounded-lg font-semibold hover:scale-105 transition-transform duration-300">
            <i className="ri-arrow-right-line mr-2"></i>
            <span className="italic">Stackway Skill Hub được thiết kế để giải quyết trọn vẹn những vấn đề này</span>
          </div>
        </div>
      </div>
    </section>
  );
}
